import React, {useState, useContext} from "react";
import './Login.css';
import UserPool from "../../UserPool";
import { CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
import { useNavigate } from 'react-router-dom';
export const Login = (props) => {

    const[formData, setFormData] = useState({
        email: "",
        password: ""
    });

    const [error, setError] = useState()

    const nav = useNavigate()
    const handleSubmit = (event) => {
        event.preventDefault();
        const user = new CognitoUser({
            Username: formData.email,
            Pool: UserPool,
        });

        const authDetails = new AuthenticationDetails({
            Username: formData.email,
            Password: formData.password,
        });
        user.authenticateUser(authDetails, {
            onSuccess: (data) => {
                let accessToken = data.getAccessToken().getJwtToken();
                console.log('Access token:', accessToken);
                nav("/home", {
                    state: data
                })
            },
            onFailure: (err) => {
                console.error('onFailure:', err)
                setError(err.message)
            },
            newPasswordRequired: (data) => {
                console.log('newPasswordRequired:', data);
            }
        })
    }

    function handleChange(event) {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    }
    return(
        // body
        <div>
            {/* top bar */}
            <div className="top-bar">
                <div className="logo-container">
                    <img src='/images/notable-logo.png' height="50" alt="notable-logo"/>
                </div>
            </div>
            <div>
                {/* left side */}
                <div className="login-image-container">
                    <img src='/images/login-photo.png'  height="100%" alt="login-photo"/>
                </div>
                {/* right side */}
                <div className="form-container">
                    <div className="form-box">
                        <h2 className="header1">Welcome Back!</h2>
                        <p className="header2">Login to continue learning.</p>
                        <form className="login-form" onSubmit={handleSubmit}>
                            <input
                                name="email"
                                className="email"
                                type="email"
                                placeholder="Email"
                                onChange={handleChange}
                                value={formData.email}
                            />
                            <br />
                            <input
                                name="password"
                                type="password"
                                placeholder="Password"
                                onChange={handleChange}
                                value={formData.password}
                            />
                            <br />
                            <button type="submit">Log In</button>
                            <br />
                            {error ? <label style={{color:'red'}}>{error}</label> : null}
                        </form>

                        <div className="sign-up-redirect">
                            <div className="header3">
                                <h4 >Don't have an account? &nbsp;</h4>
                            </div>
                            <div className="sign-up-redirect-button-container">
                                <a className='sign-up-redirect-button' href="/register">Sign Up</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}
export default Login;